import React from 'react';

const LockIcon = () => (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 4.18579H6.5V3.18579C6.5 1.80579 5.38 0.685791 4 0.685791C2.62 0.685791 1.5 1.80579 1.5 3.18579V4.18579H1C0.45 4.18579 0 4.63579 0 5.18579V10.1858C0 10.7358 0.45 11.1858 1 11.1858H7C7.55 11.1858 8 10.7358 8 10.1858V5.18579C8 4.63579 7.55 4.18579 7 4.18579ZM2.5 3.18579C2.5 2.35579 3.17 1.68579 4 1.68579C4.83 1.68579 5.5 2.35579 5.5 3.18579V4.18579H2.5V3.18579ZM7 10.1858H1V5.18579H7V10.1858ZM4 8.68579C4.55 8.68579 5 8.23579 5 7.68579C5 7.13579 4.55 6.68579 4 6.68579C3.45 6.68579 3 7.13579 3 7.68579C3 8.23579 3.45 8.68579 4 8.68579Z"
      fill="#747474"
    />
  </svg>
);

export default LockIcon;
